import { observer } from 'mobx-react';
import styled from 'styled-components';

const Wrap = styled.div<{ num: number }>`
  background: url(${require('./images/nums.png')}) 0 0 / contain no-repeat;
  width: ${(props) => {
    return props.num === 1 ? 35 : 45;
  }}px;
  display: inline-block;
  height: 100px;
  background-size: 45px 1000px;
  background-position: 0 -${(props) => {
      return props.num * 100;
    }}px;
`;

const Numbers = observer((props) => {
  const { num } = props;

  return <Wrap num={parseInt(num, 10)}></Wrap>;
});

export default Numbers;
